/**
 * @module Page-Blog-Left-Sidebar
 */

import { TypePageBlogs } from "../../@types/pageTypes";
import { useEffect, useState } from "react";
import { getBlogsGridDataWithSidebar } from "../../../api/blogs-service";
import { loadScript } from "../../../globals/common-functions";
import { BANNER_TYPE } from "../../../globals/constants";
import banner from "../../../globals/banner.json";
import SectionInnerPageBanner from "../../sections/common/banner";
import SectionBlogsSidebar from "../../sections/blogs/blogs-sidebar";
import SectionPagination from "../../sections/common/pagination";
import SectionBlogsCommonBox from "../../sections/blogs/blog-box";

/**
 * 
 * @returns Markup template for sample page Blog List with left sidebar
 */
function BlogsWithLeftSidebarPage() {

    const _blogsDefault: TypePageBlogs = {};
    const [results, setResults] = useState(_blogsDefault);
    const [isFetching, setIsFetching] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9; // Standard pagination for blogs

    useEffect(() => {

        getBlogsGridDataWithSidebar((response: TypePageBlogs) => {
            setIsFetching(false);
            setResults(response);
            loadScript("js/custom.js");
        })

    }, [isFetching])

    // Calculate pagination data
    const totalItems = results.blogs?.length || 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const shouldShowPagination = totalItems > 9; // Only show pagination if more than 9 items
    
    // Calculate the items to display on current page
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = results.blogs?.slice(startIndex, endIndex) || [];

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            // Scroll to top of blogs section
            window.scrollTo(0, 0);
        }
    };

    return (
        <>
            {/* INNER PAGE BANNER */}
            <SectionInnerPageBanner _data={banner.blog_left_sidebar} _type={BANNER_TYPE.COMPACT} />
            {/* INNER PAGE BANNER END */}

            {/* Blog SECTION START */}
            {
                (results.blogs && results.blogs!.length > 0) &&
                <div className="section-full p-t120 p-b120 site-bg-white av-case3-section-wrap">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                {/* SIDE BAR START */}
                                <div className="col-xl-4 col-lg-4 col-md-12 sticky-sidebar">
                                    <SectionBlogsSidebar _data={results.sidebar!} />
                                </div>
                                {/* SIDE BAR END */}
                                <div className="col-xl-8 col-lg-8 col-md-12">
                                    <div className="masonry-wrap row">
                                        {
                                            currentItems.map((_item, _index) => {
                                                return (
                                                    <div key={_index} className="masonry-item col-lg-6 col-md-6 col-sm-6 m-b30 wow fadeInDown" data-wow-delay="0.2">
                                                        <SectionBlogsCommonBox _data={_item} />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {shouldShowPagination && (
                                        <SectionPagination 
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {/* Blog Study SECTION END */}
        </>
    )
}
export default BlogsWithLeftSidebarPage;